import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
//import { environment } from 'environments/environment';
import { AuthService } from 'app/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ReportserviceService {
  
  patients: PatientDetailModel[] = [];
  public baseUrl :any;    
  public newbaseUrl:any;     
  // public newUrl ="http://localhost:5101/api/"    

  constructor(private http:HttpClient , public authservice: AuthService,) { 
  //  this.baseUrl = environment.ENV_baseUrl;
    this.newbaseUrl = authservice.newbaseUrl;
  }

   get_opd_sdate_edate(sdate: string, edate: string) {
     return this.http.get<any>(this.newbaseUrl + "Opd/GetPt_OPDCount_DateWise/?Fromdate=" +
       sdate + "&Todate=" + edate )
   }

   get_opd_doctor_sdate_edate(sdate: string, edate: string) {
    return this.http.get<any>(this.newbaseUrl + "Opd/GetPt_OPDCount_DoctorWise/?Fromdate=" +
      sdate + "&Todate=" + edate )
  }
  
  get_opd_piechart_sdate_edate(sdate: string, edate: string) {
    return this.http.get<any>(this.newbaseUrl + "Opd/GetPt_OPDCount_DateWise_PieChart/?Fromdate=" +
      sdate + "&Todate=" + edate )
  }

   
  get_opd_monthly_sdate_edate(sdate: string, edate: string) {
    return this.http.get<any>(this.newbaseUrl + "Opd/GetPt_OPDCount_MonthWise/?Fromdate=" +
      sdate + "&Todate=" + edate )
  }
  



  get_Category_data_sdate_edate(sdate: string, edate: string,CATEGORYid) {
    console.log(this.newbaseUrl+"Register/GetPatient_CategoryId/?"+"Fromdate="+sdate+"&Todate="+edate+"&CATEGORYid="+CATEGORYid);
    return this.http.get<any>(this.newbaseUrl+"Register/GetPatient_CategoryId/?"+"Fromdate="+sdate+"&Todate="+edate+"&CATEGORYid="+CATEGORYid)
  }

  get_CategoryName_data_sdate_edate(sdate: string, edate: string,CategoryName) {
    return this.http.get<any>(this.newbaseUrl+"Register/GetPatient_CategoryName/?"+"Fromdate="+sdate+"&Todate="+edate+"&CategoryName="+CategoryName)
  }

  //Appointment DR. Wise report get

  get_doctor_data_sdate_edate(sdate: string, edate: string,DRID) {
    return this.http.get<any>(this.newbaseUrl+"Register/GetPatient_DRID/?"+"Fromdate="+sdate+"&Todate="+edate+"&DRID="+DRID)
  }
  get_doctorName_data_sdate_edate(sdate: string, edate: string,DRName) {
    return this.http.get<any>(this.newbaseUrl+"Register/GetPatient_DRName/?"+"Fromdate="+sdate+"&Todate="+edate+"&DRName="+DRName)
  }




// new Reports 


// billing collection  reports 

  getbillingcollectionReportByid(){
    return this.http.get<any>(this.newbaseUrl);
 }
 getbillingReportbyparty(){
  return this.http.get<any>(this.newbaseUrl);
}


getbillingCollectionReport(sdate: string, BranchId: any ,userid:any) {
  // console.log(this.newbaseUrl + "Reports/GetCollectionDetailByTranDateByBranchId/" +
  // sdate + "/" + BranchId)
  return this.http.get<any>(this.newbaseUrl + "Reports/GetCollectionDetailByTranDateByBranchId/" +
    sdate + "/" + BranchId +'/'+userid )
}

get_misreport_data(userid:any, actualName:any){
  return this.http.get<any>(this.newbaseUrl + "Reports/GetWebMisReportUserPermissionDetailByUserIdByActualName/" + userid + "/" + actualName )
 //return this.http.get<any>(this.newbaseUrl + "Reports/GetWebMisReportUserPermissionDetailByActualName/" + actualName )
  
}

insert_web_MisReportMaster(payload){
  return this.http.post<any>(this.newbaseUrl + "Reports/InsertWebMisReportUserPermissionDetail",payload);
}




getbillingRegisterReport(sdate: string, edate: string) {
  // console.log(this.newbaseUrl + "Reports/GetBillsFromDateToDate/" +
  // sdate + "/" + edate)
  return this.http.get<any>(this.newbaseUrl + "Reports/GetBillsFromDateToDate/" +
    sdate + "/" + edate )
}

getbillModificationReport(sdate: string, edate: string) {

  return this.http.get<any>(this.newbaseUrl + "Reports/GetBillModificationDetailsFromDateToDate/" +
    sdate + "/" + edate )
}

// opd rpoets date wise doctor wise and month wise reports

getOpdCommonReport(sdate: string, edate: string,commonpara:any) {

  return this.http.get<any>(this.newbaseUrl + "Reports/GetOpdSummaryByFromDateToDateGroupBy/" +
    sdate + "/" + edate + "/" + commonpara)
}

getRegistrationCommonReports(sdate: string, edate: string,type:string){
  return this.http.get<any>(this.newbaseUrl + "Reports/GetPatientByFromDateToDateGroupBy/" +
  sdate + "/" + edate + "/" + type) 
}

//http://10.1.13.58:6001/api/Reports///1/2022-05-01/2022-05-01/2022-06-01/2022-06-01

getBillingComparesionReports(BranchId:any,compsdate: string, compedate: string,sdate: string, edate: string){
  console.log(this.newbaseUrl + "Reports/GetMISRevenueByTypeByBranchIdByFromDateByToDateByFromDate1ByToDate1/Service/" +BranchId+'/'+
  + compsdate + "/" + compedate + "/"   + sdate + "/" + edate)
  return this.http.get<any>(this.newbaseUrl + "Reports/GetMISRevenueByTypeByBranchIdByFromDateByToDateByFromDate1ByToDate1/Service/"
   +BranchId+'/'+ compsdate + "/" + compedate + "/"   + sdate + "/" + edate ) 
}


  getReportMasterGrp() {
    return this.http.get<any>(this.newbaseUrl + "Reports/GetReportGroup");
  }

  getReportGrpList() {
    return this.http.get<any>(this.newbaseUrl + "Reports/GetReportMasterByReportGroup/0");
  }

  getReportFilter(reportgrp) {
    return this.http.get<any>(this.newbaseUrl + "Reports/GetReportMasterByReportGroup/" + reportgrp);
  }
  
  getEyeInvestigationSummary(fdate: string, tdate: string){
    return this.http.get<any>(this.newbaseUrl + "Reports/GetEyeInvestigationSummaryFromDateToDate/" +
    fdate + "/" + tdate) 
  }
  getDoctorWiseInvestigationRevenue(fdate: string, tdate: string, BranchId: any){
    return this.http.get<any>(this.newbaseUrl + "Reports/GetDoctorwiseInvestigationRevenueFromDateToDate/" +
    fdate + "/" + tdate + "/" + BranchId) 
  }
  getOperationTypeWiseRevenueReport(fdate: string, tdate: string, BranchId: any){
    return this.http.get<any>(this.newbaseUrl + "Reports/GetIPDSurgeryRevenueFromDateToDate/" +
    fdate + "/" + tdate + "/" + BranchId) 
  }

  getAdvanceRegister(branchId: any, fdate: string, tdate: string) {
    return this.http.get<any>(this.newbaseUrl + "Reports/GetAdvanceRegisterByBranchIdFromDateToDate/" +  branchId + "/" + fdate + "/" + tdate)
  }
  getAppointmentSummeryDocterWiseReport(branchId: any, fdate: string, tdate: string) {
    return this.http.get<any>(this.newbaseUrl + "Reports/GetAppointmentSummaryByBranchIdFromDateToDateByGroupBy/" +  branchId + "/" + fdate + "/" + tdate + "/" +"Doctor")
  }
  getAppointmentRegDocterWiseReport(branchId: any, fdate: string, tdate: string, doctorid:any) {
    return this.http.get<any>(this.newbaseUrl + "Reports/GetAppointmentRegisterDocwiseFromDateToDate/" +  branchId + "/" + fdate + "/" + tdate + "/" + doctorid )
  }
  getMisReportMaster(){
    return this.http.get<any>(this.newbaseUrl + "Reports/GetMisReportMaster");
  }
  
  insertMisReportMaster(payload){
    return this.http.post<any>(this.newbaseUrl + "Reports/InsertMisReportMaster",payload);
  }
  // getMisReportColumnView(viewName:any){
  //   return this.http.get<any>(this.newbaseUrl + "Reports/GetMisReportMasterColumnsByObjectName/"+viewName);
  // }
  getMisReportColumnView(payload:any){
    return this.http.post<any>(this.newbaseUrl + "Reports/GetMisReportMasterColumnsByObjectName",payload);
  }
  getMisReportdataView(viewName:any){
    return this.http.get<any>(this.newbaseUrl + "Reports/GetMisReportMasterDataByObjectName/"+viewName);
  }
  postMisReportdataView(payload:any){
    return this.http.post<any>(this.newbaseUrl + "Reports/GetMisReportMasterDataByObjectNameDynamic",payload);
  // return this.http.post<any>(this.newbaseUrl + "Reports/GetMisReportMasterDataByObjectName",payload);
  }
  GetMonthlyServiceWiseStatistics(month) {
    return this.http.get<any>(this.newbaseUrl + "Reports/GetMonthlyServiceWiseStatistics/" + month );
  }
  getServiceConsumptionReport(sdate: string) {
    return this.http.get<any>(this.newbaseUrl + "Reports/GetServiceConsumptionSummary/" + sdate)
  }
}
